import validate from "/usr/src/app/content/n3-spas-9fff53fa-cba4-4e91-bacf-389fc9785ca2/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-9fff53fa-cba4-4e91-bacf-389fc9785ca2/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}